<template>

  <button
    type="button"
    class="btn btn-dark btn-sm "
    :class="{'box-loading': loading}"
    @click="follow(following?'unfollow':'follow')">
    <i class="fas fa-rss" :class="{'text-success': following, 'text-secondary': !following}" />
    {{ following ? $t('Following') : $t('Follow') }}
    </button>

</template>

<script>
export default {
  name: 'CandidateFolow',
  components: {
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    me () {
      return this.$store.getters.getMe
    },
    following () {
      return this.candidate.followers ? this.candidate.followers.find((val) => {
        return val === this.me._id
      }) : null
    }
  },
  created () {
  },
  methods: {
    follow (action) {
      this.loading = true
      this.$store
      .dispatch('followCandidate', {
        candidate_id: this.candidate._id,
        action: action
      })
      .then((result) => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Header/CandidateFollow.vue